/* eslint-disable no-trailing-spaces */
/* eslint no-console: 0 */
/* eslint max-len: 0 */
/* eslint camelcase: off */

// imports
import * as utils from './utils';
import * as datePicker from './date-picker';
import * as epiForm from './epi-form-validate';
import {getEpiRecommendations} from './epiTrack';
import env from './env';

// polyfills
import 'regenerator-runtime';
import 'whatwg-fetch';
import 'web-animations-js';

// Widgets
import {loadQuantityInput} from 'widgets/quantityInput/js/loadWg';
import {loadListingFilters} from 'widgets/listingFilters/js/loadWg';
import {loadShoppingCartItem} from 'widgets/shoppingCartItem/js/loadWg';
import {loadFormValidation} from 'widgets/formValidation/js/loadWg';
import {loadGiftRegistrySidebar} from 'widgets/giftRegistrySidebar/js/loadWg';
import {loadWishlistItem} from 'widgets/wishlistItem/js/loadWg';
import {loadGiftRegistryItem} from 'widgets/giftRegistryItem/js/loadWg';
import {loadMiniCart} from 'widgets/miniCart/js/loadWg';
import {loadPimDashboardFilters} from 'widgets/pimDashboardFilters/js/loadWg';
import {loadPimDashboardHeader} from 'widgets/pimDashboardHeader/js/loadWg';
import {loadCallToAction} from 'widgets/callToAction/js/loadWg';
import {loadAccountSidebar} from 'widgets/accountSidebar/js/loadWg';
import {loadPagesResults} from 'widgets/pagesResults/js/loadWg';
import {loadNotifications} from 'widgets/notifications/js/loadWg';
import {loadAddressAutocomplete} from 'widgets/addressAutocomplete/js/loadWg';
import {loadReviewForm} from 'widgets/reviewForm/js/loadWg';
import {loadReviewList} from 'widgets/reviewList/js/loadWg';
import {loadRecommendationsModal} from 'widgets/recommendationsModal/js/loadWg';
import {loadRegionStoreSelector} from 'widgets/regionStoreSelector/js/loadWg';
import {loadRegionStorePopup} from 'widgets/regionStorePopup/js/loadWg';
import {loadStoreAvailability} from 'widgets/storeAvailability/js/loadWg';
import {loadHeaderCart} from 'widgets/headerCart/js/loadWg';
import {loadMessageIntoView} from 'widgets/messageIntoView/js/loadWg';
import {loadRuralPopup} from 'widgets/ruralPopup/js/loadWg';

// Blocks
import {loadVideoFeature} from 'blocks/videoFeature/js/loadBlk';
import {loadProductListing} from 'blocks/productListing/js/loadBlk';
import {loadSiteHeader} from 'blocks/siteHeader/js/loadBlk';
import {loadBrandNavigation} from 'blocks/brandNavigation/js/loadBlk';
import {loadProductListingBlock} from 'blocks/productListingBlock/js/loadBlk';
import {loadProductAccordion} from 'blocks/productAccordion/js/loadBlk';
import {loadInstagramFeed} from 'blocks/instagramFeed/js/loadBlk';
import {loadFullWidthPromo} from 'blocks/fullWidthPromo/js/loadBlk';
import {loadMegaMenuTab} from 'blocks/megaMenuTab/js/loadBlk';
import {loadMegaMenuBrand} from 'blocks/megaMenuBrand/js/loadBlk';
import {loadMegaMenu} from 'blocks/megaMenu/js/loadBlk';
import {loadProductCarousel} from 'blocks/productCarousel/js/loadBlk';
import {loadKlevuSearch} from 'blocks/klevuSearch/js/loadBlk';
import {loadKlevuResultsListingBlock} from 'blocks/klevuResultsListingBlock/js/loadBlk';
import {loadCheckGiftCardBalance} from 'blocks/CheckGiftCardBalance/js/loadBlk';
import {loadGiftCardPayment} from 'blocks/giftCardPayment/js/loadBlk';
import {loadPromoHeroCarousel} from 'blocks/promoHeroCarousel/js/loadBlk';
import {loadCategoryCarousel} from 'blocks/categoryCarousel/js/loadBlk';
import {loadSubscribeForm} from 'blocks/subscribeForm/js/loadBlk';
import {loadFeaturePanelWidthHalf} from 'blocks/featurePanelWidthHalf/js/loadBlk';
import {loadToggleSection} from 'blocks/toggleSection/js/loadBlk';
import {loadSelectBox} from 'blocks/selectbox/js/loadBlk';
import {loadProductQuickView} from 'blocks/productQuickView/js/loadBlk';
import {loadNearbyStores} from 'blocks/nearbyStores/js/loadBlk';
import {loadTableList} from 'blocks/tableList/js/loadBlk';
import {loadProductQuiz} from 'blocks/productQuiz/js/loadBlk';
import {loadLoginCdc} from 'blocks/loginCdc/js/loadBlk';
import {loadRegisterCdc} from 'blocks/registerCdc/js/loadBlk';
import {loadUpdateProfileCdc} from 'blocks/updateProfileCdc/js/loadBlk';
import {loadChangePasswordCdc} from 'blocks/changePasswordCdc/js/loadBlk';
import {loadCheckoutLoginCard} from 'blocks/checkoutLoginCard/js/loadBlk';
import {loadAddressBookCdc} from 'blocks/addressBookCdc/js/loadBlk';
import {loadMailingListCdc} from 'blocks/mailingListCdc/js/loadBlk';
import {loadWishCartItem} from 'blocks/wishCartItem/js/loadBlk';
import {loadFormCdc} from 'blocks/formCdc/js/loadBlk';
import {loadButtonContainer} from 'blocks/buttonContainer/js/loadBlk';
import {loadAddressOptions} from 'blocks/addressOptions/js/loadBlk';
import {loadSignUpCdc} from 'blocks/signUpCdc/js/loadBlk';
import {loadInpageSubmission} from 'blocks/inpageSubmission/js/loadBlk';
import {loadCtaButtonCarousel} from 'blocks/ctaButtonCarousel/js/loadBlk';
import {loadPromotionalList} from 'blocks/promotionalList/js/loadBlk';

// Pages
import {loadCartStep_1Page} from 'pages/cartStep_1Page/js/loadPg';
import {loadOrderHistoryPage} from 'pages/orderHistoryPage/js/loadPg';
import {loadOrderHistoryDetailsPage} from 'pages/orderHistoryDetailsPage/js/loadPg';
import {loadCartStep_2Page} from 'pages/cartStep_2Page/js/loadPg';
import {loadCartStep_4PaymentPage} from 'pages/cartStep_4PaymentPage/js/loadPg';
import {loadCartStep_3GuestPage} from 'pages/cartStep_3GuestPage/js/loadPg';
import {loadCartStep_3LoggedInPage} from 'pages/cartStep_3LoggedInPage/js/loadPg';
import {loadFindGiftRegistryPage} from 'pages/findGiftRegistryPage/js/loadPg';
import {loadGiftRegistryRegisterAndSetupPage} from 'pages/giftRegistryRegisterAndSetupPage/js/loadPg';
import {loadGiftRegistryItemDetailsPage} from 'pages/giftRegistryItemDetailsPage/js/loadPg';
import {loadAddressBookPage} from 'pages/addressBookPage/js/loadPg';
import {loadGiftRegistriesPage} from 'pages/giftRegistriesPage/js/loadPg';
import {loadPimDashboardPromotionsPage} from 'pages/pimDashboardPromotionsPage/js/loadPg';
import {loadPimDashboardBuyerPage} from 'pages/pimDashboardBuyerPage/js/loadPg';
import {loadUpdateEmailPage} from 'pages/updateEmailPage/js/loadPg';
import {loadUpdatePasswordPage} from 'pages/updatePasswordPage/js/loadPg';
import {loadCreateAccountPage} from 'pages/createAccountPage/js/loadPg';
import {loadForgotPasswordPage} from 'pages/forgotPasswordPage/js/loadPg';
import {loadLoginPage} from 'pages/LoginPage/js/loadPg';
import {loadUpdatePersonalDetailsPage} from 'pages/updatePersonalDetailsPage/js/loadPg';
import {loadGiftRegistryManagementDetailsPage} from 'pages/giftRegistryManagementDetailsPage/js/loadPg';
import {loadUpdateCreditCard} from 'pages/updateCreditCard/js/loadPg';
import {loadProductDetailsPage} from 'pages/productDetailsPage/js/loadPg';
import {loadStoreFinderPage} from 'pages/storeFinderPage/js/loadPg';
import {loadSearchResultsPage} from 'pages/searchResultsPage/js/loadPg';
import {loadCartStep_5GuestPage} from 'pages/cartStep_5GuestPage/js/loadPg';
import {loadCartStep_5LoggedInPage} from 'pages/cartStep_5LoggedInPage/js/loadPg';
import {loadWishlistPage} from 'pages/wishlistPage/js/loadPg';
import {loadNotFoundPage} from 'pages/notFoundPage/js/loadPg';
import {loadEGiftCardDetailsPage} from 'pages/eGiftCardDetailsPage/js/loadPg';
import {loadPhysicalGiftCardDetailsPage} from 'pages/physicalGiftCardDetailsPage/js/loadPg';
import {loadOrderConfirmationPage} from 'pages/orderConfirmationPage/js/loadPg';
import {loadVideoAndTextBlock} from '../../views/blocks/videoAndTextBlock/js/loadBlk';
import {loadCommunicationPreferences} from 'pages/communicationPreferences/js/loadPg';
import {loadOrderListingCdc} from 'pages/orderListingCdc/js/loadPg';
import {loadForgotPasswordCdc} from 'pages/forgotPasswordCdc/js/loadPg';
import {loadResetPasswordCdc} from 'pages/resetPasswordCdc/js/loadPg';
import {loadWishlistCdc} from 'pages/wishlistCdc/js/loadPg';
import {loadOrderDetailCdc} from 'pages/orderDetailCdc/js/loadPg';

let NS = 'briscoesEcomm';
window[NS] = {};

$(document).ready(function() {
	// add any generic code that is not widget-specific here

	// load blocks here //
	// Start ProductListingBlock script
	loadProductListingBlock(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading ProductListingBlock script`);
	// End ProductListingBlock script

	// Start ProductListing script
	loadProductListing(document.body).then((blk) => {
		blk ? blk.init() : '';
	}).catch((error) => `${error} An error occurred while loading ProductListing script`);
	// End ProductListing script

	// Start video feature script
	loadVideoFeature(document.body).then((blk) => {
		blk ? blk.init() : '';
	}).catch((error) => `${error} An error occurred while loading VideoFeature script`);
	// End video feature script

	// Start video feature script
	loadVideoAndTextBlock(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading VideoAndTextBlock script`);
	// End video feature script

	// Start siteHeader script
	loadSiteHeader(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading SiteHeader script`);
	// End siteHeader script

	// Start brandNavigation script
	loadBrandNavigation(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading brandNavigation script`);
	// End brandNavigation script

	// Start productAccordion script
	loadProductAccordion(document.body, true).then((blkAll) => {
		// blk ? blk.init() : '';
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading productAccordion script`);
	// End productAccordion script

	// Start instagramFeed script
	loadInstagramFeed(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}): '';
	}).catch((error) => `${error} An error occurred while loading instagramFeed script`);
	// End instagramFeed script

	// Start fullWidthPromo script
	loadFullWidthPromo(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}): '';
	}).catch((error) => `${error} An error occurred while loading fullWidthPromo script`);
	// End fullWidthPromo script

	// Start loadMegaMenuTab script
	loadMegaMenuTab(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadMegaMenuTab script`);
	// End loadMegaMenuTab script

	// Start loadMegaMenuBrand script
	loadMegaMenuBrand(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadMegaMenuBrand script`);
	// End loadMegaMenuBrand script

	// Start loadMegaMenu script
	loadMegaMenu(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadMegaMenu script`);
	// End loadMegaMenu script

	// Start loadProductCarousel script
	loadProductCarousel(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadProductCarousel script`);
	// End loadProductCarousel script

	// Start loadKlevuSearch script
	loadKlevuSearch(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk, i) => {
			setTimeout(() => {
				blk.init();
			}, 0);
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadKlevuSearch script`);
	// End loadKlevuSearch script

	// Start loadKlevuResultsListingBlock script
	loadKlevuResultsListingBlock(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadKlevuResultsListingBlock script`);
	// End loadKlevuResultsListingBlock script

	// Start loadCheckGiftCardBalance script
	loadCheckGiftCardBalance(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadCheckGiftCardBalance script`);
	// End loadCheckGiftCardBalance script

	// Start loadGiftCardPayment script
	loadGiftCardPayment(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadGiftCardPayment script`);
	// End loadGiftCardPayment script

	// Start loadPromoHeroCarousel script
	loadPromoHeroCarousel(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadPromoHeroCarousel script`);
	// End loadPromoHeroCarousel script

	// Start loadCategoryCarousel script
	loadCategoryCarousel(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadCategoryCarousel script`);
	// End loadCategoryCarousel script

	// Start loadAddressAutocomplete script
	loadAddressAutocomplete(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadAddressAutocomplete script`);
	// End loadAddressAutocomplete script

	// Start loadSubscribeForm script
	loadSubscribeForm(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadSubscribeForm script`);
	// End loadSubscribeForm script

	// Start loadMailingListCdc script
	loadMailingListCdc(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadMailingListCdc script`);
	// End loadMailingListCdc script

	// Start loadFormCdc script
	loadFormCdc(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadFormCdc script`);
	// End loadFormCdc script

	// Start loadWishCartItem script
	loadWishCartItem(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadWishCartItem script`);
	// End loadWishCartItem script

	// loadFeaturePanelWidthHalf
	loadFeaturePanelWidthHalf(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadFeaturePanelWidthHalf script`);
	// end loadFeaturePanelWidthHalf script

	// loadNearbyStores
	loadNearbyStores(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadNearbyStores script`);
	// end loadNearbyStores script

	// loadTableList
	loadTableList(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadTableList script`);
	// end loadTableList script

	// loadNearbyStores
	loadProductQuiz(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadProductQuiz script`);
	// end loadProductQuiz script

	// loadButtonContainer
	loadButtonContainer(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadButtonContainer script`);
	// end loadButtonContainer script

	// loadAddressOptions
	loadAddressOptions(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadAddressOptions script`);
	// end loadAddressOptions script

	// loadSignUpCdc
	loadSignUpCdc(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadSignUpCdc script`);
	// end loadSignUpCdc script

	// loadInpageSubmission
	loadInpageSubmission(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadInpageSubmission script`);
	// end loadInpageSubmission script

	// loadCtaButtonCarousel
	loadCtaButtonCarousel(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadCtaButtonCarousel script`);
	// end loadCtaButtonCarousel script

	// loadPromotionalList
	loadPromotionalList(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadPromotionalList script`);
	// end loadPromotionalList script

	// load widgets here //

	// Start Gift Registry Sidebar widget
	loadGiftRegistrySidebar(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((error) => `${error} An error occurred while loading GiftRegistrySidebar widget`);
	// End Gift Registry Sidebar widget

	// Start Listing Filters widget
	loadListingFilters(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading ListingFilters script`);
	// End Listing Filters widget

	// Start account sidebar script
	loadAccountSidebar(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((error) => `${error} An error occurred while loading AccountSidebar script`);
	// End account sidebar script

	// Start quantity input script
	loadQuantityInput(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading QuantityInput script`);
	// End quantity input script

	// Start ShoppingCartItem script
	loadShoppingCartItem(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}): '';
	}).catch((error) => `${error} An error occurred while loading ShoppingCartItem script`);
	// End ShoppingCartItem script

	// Start form validation script
	loadFormValidation(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading FormValidation script`);
	// End form validation script

	// Start wishlistItem script
	loadWishlistItem(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading wishlistItem script`);
	// End wishlistItem script

	// Start GiftRegistryItem script
	loadGiftRegistryItem(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading GiftRegistryItem script`);
	// End GiftRegistryItem script

	// Start miniCart script
	loadMiniCart(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading miniCart script`);
	// End miniCart script

	// Start PimDashboardFilters script
	loadPimDashboardFilters(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((error) => `${error} An error occurred while loading PimDashboardFilters script`);
	// End PimDashBoardFilters script

	// Load PIMDashboardHeader script
	loadPimDashboardHeader(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((error) => `${error} An error occurred while loading PIMDashboardHeader script`);
	// End PIMDashboardHeader script

	// Load CallToAction widgets
	loadCallToAction(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading CallToAction script`);
	// End CallToAction script

	// Load loadPagesResults widget
	loadPagesResults(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading PagesResults script`);
	// end loadPagesResults script

	// loadNotifications widget
	loadNotifications(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadNotifications script`);
	// end loadNotifications script

	// loadReviewForm widget
	loadReviewForm(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadReviewForm script`);
	// end loadReviewForm script

	// loadReviewList widget
	loadReviewList(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadReviewList script`);
	// end loadReviewList script

	// loadRecommendationsModal widget
	loadRecommendationsModal(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadRecommendationsModal script`);
	// end loadRecommendationsModal script

	// loadRegionStoreSelector widget
	loadRegionStoreSelector(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadRegionStoreSelector script`);
	// end loadRegionStoreSelector script

	// loadRegionStorePopup widget
	loadRegionStorePopup(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadRegionStorePopup script`);
	// end loadRegionStorePopup script

	// loadStoreAvailability widget
	loadStoreAvailability(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadStoreAvailability script`);
	// end loadStoreAvailability script

	// loadRuralPopup widget
	loadRuralPopup(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadRuralPopup script`);
	// end loadRuralPopup script

	// load pages here //

	// Load cart step 1 script
	loadCartStep_1Page(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading cart step 1 script`);
	// End cart step 1 script

	// Load orderHistoryPage script
	loadOrderHistoryPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading OrderHistoryPage script`);
	// End orderHistoryPage script

	// Load OrderListingCdc script
	loadOrderListingCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading OrderHistoryPage script`);
	// End OrderListingCdc script

	// Load orderHistoryDetailsPage script
	loadOrderHistoryDetailsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading OrderHistoryDetailsPage script`);
	// End orderHistoryDetailsPage script

	// Load cart step 2 script
	loadCartStep_2Page(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading cart step 2 script`);
	// End cart step 2 script

	// Load cart step 5 script
	loadCartStep_4PaymentPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading cart step 5 script`);
	// End cart step 5 script

	// Load cart step 3 guest script
	loadCartStep_3GuestPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading cart step 3 script`);
	// End cart step 3 guest script

	// Load cart step 3 logged in script
	loadCartStep_3LoggedInPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading cart step 3 script`);
	// End cart step 3 logged in script

	// Load FindGiftRegistryPage script
	loadFindGiftRegistryPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading FindGiftRegistryPage script`);
	// End FindGiftRegistryPage script

	// Load GiftRegistryRegisterAndSetupPage script
	loadGiftRegistryRegisterAndSetupPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading GiftRegistryRegisterAndSetupPage script`);
	// End GiftRegistryRegisterAndSetupPage script

	// Load loadGiftRegistryItemDetailsPage script
	loadGiftRegistryItemDetailsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading GiftRegistryItemDetailsPage script`);
	// End loadGiftRegistryItemDetailsPage script

	// Load address book script
	loadAddressBookPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading address book script`);
	// End address book script

	// Load GiftRegistriesPage script
	loadGiftRegistriesPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading GiftRegistriesPage script`);
	// End GiftRegistriesPage script

	// Load PimDashboardPromotionsPage script
	loadPimDashboardPromotionsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading PimDashboardPromotionsPage script`);
	// End PimDashboardPromotionsPage script

	// Load PimDashboardBuyerPage script
	loadPimDashboardBuyerPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading PimDashboardBuyerPage script`);
	// End PimDashboardBuyerPage script

	// Load UpdateEmailPage script
	loadUpdateEmailPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading UpdateEmailPage script`);
	// End UpdateEmailPage script

	// Load UpdatePasswordPage script
	loadUpdatePasswordPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading UpdatePasswordPage script`);
	// End UpdatePasswordPage script

	// Load CreateAccountPage script
	loadCreateAccountPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading CreateAccountPage script`);
	// End CreateAccountPage script

	// Load ForgotPasswordPage script
	loadForgotPasswordPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading ForgotPasswordPage script`);
	// End ForgotPasswordPage script

	// Load LoginPage script
	loadLoginPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading LoginPage script`);
	// End LoginPage script

	// Load UpdatePersonalDetailsPage script
	loadUpdatePersonalDetailsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading LoginPage script`);
	// End UpdatePersonalDetailsPage script

	// Load loadGiftRegistryManagementDetailsPage scrit
	loadGiftRegistryManagementDetailsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadGiftRegistryManagementDetailsPage script`);
	// End loadGiftRegistryManagementDetailsPage script

	// Load UpdateCreditCardPage script
	loadUpdateCreditCard(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading UpdateCreditCardPage script`);
	// End UpdateCreditCardPage script

	// Load productDetailsPage script
	loadProductDetailsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading productDetailsPage script`);
	// End productDetailsPage script

	// Load storeFinderPage script
	loadStoreFinderPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading storeFinderPage script`);
	// End storeFinderPage script

	// loadSearchResultsPage script
	loadSearchResultsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading SearchResultsPage script`);
	// End loadSearchResultsPage script

	// loadCartStep_5GuestPage script
	loadCartStep_5GuestPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading cartStep5GuestPage script`);
	// End loadCartStep_5GuestPage script

	// loadCartStep_5LoggedInPage script
	loadCartStep_5LoggedInPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading cartStep5LoggedInPage script`);
	// End loadCartStep_5LoggedInPage script

	// loadWishlistPage script
	loadWishlistPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading wishlistPage script`);
	// End loadWishlistPage script

	// loadNotFoundPage
	loadNotFoundPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading wishlistPage script`);
	// end loadNotFoundPage script

	// loadEGiftCardDetailsPage
	loadEGiftCardDetailsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading eGiftCardDetailsPage script`);
	// end loadEGiftCardDetailsPage script

	// loadPhysicalGiftCardDetailsPage
	loadPhysicalGiftCardDetailsPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading physicalGiftCardDetailsPage script`);
	// end loadPhysicalGiftCardDetailsPage script

	// loadOrderConfirmationPage
	loadOrderConfirmationPage(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading orderConfirmationPage script`);
	// end loadOrderConfirmationPage script


	// loadToggleSection
	loadToggleSection(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadToggleSection script`);
	// end loadToggleSection script

	// loadSelectBox
	loadSelectBox(document.body, true).then((blkAll) => {
		(blkAll && blkAll.length > 0) ? blkAll.forEach((blk) => {
			blk.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading loadSelectBox script`);
	// end loadSelectBox script

	// loadProductQuickView
	loadProductQuickView(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadProductQuickView script`);
	// end loadProductQuickView script

	// loadLoginCdc
	loadLoginCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadLoginCdc script`);
	// end loadLoginCdc script

	// loadRegisterCdc
	loadRegisterCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadRegisterCdc script`);
	// end loadRegisterCdc script

	// loadUpdateProfileCdc
	loadUpdateProfileCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadUpdateProfileCdc script`);
	// end loadUpdateProfileCdc script

	// loadChangePasswordCdc
	loadChangePasswordCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadChangePasswordCdc script`);
	// end loadChangePasswordCdc script

	// Load loadCommunicationPreferences script
	loadCommunicationPreferences(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadCommunicationPreferences script`);
	// End loadCommunicationPreferences script

	// loadCheckoutLoginCard
	loadCheckoutLoginCard(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadCheckoutLoginCard script`);
	// end loadCheckoutLoginCard script

	// loadAddressBookCdc
	loadAddressBookCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadAddressBookCdc script`);
	// end loadAddressBookCdc script

	// loadForgotPasswordCdc
	loadForgotPasswordCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadForgotPasswordCdc script`);
	// end loadForgotPasswordCdc script

	// loadResetPasswordCdc
	loadResetPasswordCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadResetPasswordCdc script`);
	// end loadResetPasswordCdc script

	// loadWishlistCdc
	loadWishlistCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadWishlistCdc script`);
	// end loadWishlistCdc script

	// loadOrderDetailCdc
	loadOrderDetailCdc(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadOrderDetailCdc script`);
	// end loadOrderDetailCdc script

	// loadHeaderCart
	loadHeaderCart(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadHeaderCart script`);
	// end loadHeaderCart script

	// loadMessageIntoView
	loadMessageIntoView(document.body).then((pg) => {
		pg ? pg.init() : '';
	}).catch((error) => `${error} An error occurred while loading loadMessageIntoView script`);
	// end loadMessageIntoView script


	// global components and scripts //

	// Custom validate epi form
	epiForm.validatePhone();

	// check themes and load fonts
	checkTheme();

	// handle theme switcher
	handleThemeSwitcher();

	// init date pickers
	datePicker.initDatePickers();

	// FF
	// inline css fixes
	utils.handleFFBreakingCols();

	// create the sharing object for addThis
	utils.createSharingObj();

	// https://levogroup.atlassian.net/browse/BRIS-3475 emarsysDataPush
	utils.pushEmarsysData();

	getEpiRecommendations();
});

// themeing functions

function checkTheme() {
	let theme = localStorage.getItem('theme');
	if (theme) {
		utils.switchTheme(theme);
		$('#themeSwitcher').val(theme);
	}

	// load fonts only locally and on surge
	// fonts are loaded on prod the BE project based on the loaded site
	if (env == 'dev' || env == 'deploy') {
		utils.fontLoader();
	}
}

function handleThemeSwitcher() {
	$('#themeSwitcher').on('change', function() {
		let theme = this.value;
		localStorage.setItem('theme', theme);
		utils.switchTheme(theme);
		window.location.reload();
	});
}

(function(global) {
	/*
	 * Adds or updates url query params
	 * @param uri - The url to add, update the query params on.
	 * @param key - Query param key.
	 * @param value - Value for the query param.
	 * @return Newly created Uri with updated query params.
	 */
	function updateQueryStringParameter(uri, key, value) {
		let re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
		let separator = uri.indexOf('?') !== -1 ? '&' : '?';
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		} else {
			return uri + separator + key + '=' + value;
		}
	}
	// global[NS].updateQueryStringParameter = updateQueryStringParameter;
})(window);




// WEBPACK FOOTER //
// ./scripts.js